import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AgreementModel } from '@fi-shared/fi-agreement/agreement.model';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { DropdownListSettingsLanguageModel } from '@fi-shared/dropdown';
import { IDropdownSelectLanguageSettingsItem } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { AgreementPublishedContentModel } from '@fi-shared/fi-agreement/agreement-published-content.model';

@Component({
    selector: 'fi-agreement-view-agreement',
    templateUrl: './agreement-view-agreement.component.html',
    styleUrls: ['./agreement-view-agreement.component.scss'],
    host: { class: 'fi-agreement-view-agreement' },
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiAgreementViewAgreementComponent implements OnInit {
    @Input() agreement: AgreementModel;
    @Input() languageId: number;

    languageListData: DropdownListSettingsLanguageModel<IDropdownSelectLanguageSettingsItem>;
    selectedLanguageId: number;
    publishedContent: AgreementPublishedContentModel;
    showVersions: boolean;

    constructor(
        private contentLanguagesService: ContentLanguagesService,
        private stateAccessCheckService: StateAccessCheckService,
        private stateService: FiStateService,
        private userDataService: FiUserDataService,
    ) {}

    ngOnInit() {
        this.languageListData = this.contentLanguagesService.GetDropdownListSettingsLanguage();
        this.showVersions = this.stateAccessCheckService.isStateAllowedForCurrentUser(
            FiStateNames.Agreement.View.Version,
        );
        this.selectedLanguageId = this.languageId
            ? this.languageId
            : this.agreement.GetPublishedContentByContentLanguage(
                    this.userDataService.userData.PreferredContentLanguage,
                ).Content
              ? this.userDataService.userData.PreferredContentLanguage
              : this.contentLanguagesService.GetDefaultLanguageId();

        this.updateLanguageUrl();
        this.updatePublishedContent();
    }

    onSelectedLanguageChange() {
        this.updatePublishedContent();
        this.updateLanguageUrl();
    }

    updatePublishedContent() {
        this.publishedContent = this.agreement.GetPublishedContentByContentLanguage(this.selectedLanguageId);
    }

    private updateLanguageUrl() {
        this.stateService.go(
            'Agreement.View',
            {
                Id: this.stateService.params.Id,
                languageId: this.selectedLanguageId,
            },
            {
                inherit: false,
                location: 'replace',
                notify: false,
            },
        );
    }
}
